import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Frequency as GalaxyFrequency } from '@vendasta/galaxy/frequency';

@Component({
  selector: 'inventory-ui-frequency-selector',
  templateUrl: './frequency-selector.component.html',
  styleUrls: ['./frequency-selector.component.scss'],
})
export class FrequencySelectorComponent {
  @Input() selectedFrequency: GalaxyFrequency = GalaxyFrequency.MONTHLY;

  @Output() frequencySelectionChange = new EventEmitter<GalaxyFrequency>();

  frequencyOptions = [
    { label: 'BILLING_FREQUENCY.ONE_TIME', value: GalaxyFrequency.ONE_TIME },
    { label: 'BILLING_FREQUENCY.MONTHLY', value: GalaxyFrequency.MONTHLY },
    { label: 'BILLING_FREQUENCY.YEARLY', value: GalaxyFrequency.YEARLY },
  ];

  handleBillingFrequencyChange(frequency: GalaxyFrequency): void {
    this.frequencySelectionChange.emit(frequency);
  }
}
